import PrzekazyGetListGrouped from "./przekazyGetListGrouped";

const data = () => {
	return PrzekazyGetListGrouped();
};

export default data;
